import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKeys from "../constants/queryKeys";
import documentService from "../services/documentService";

const useUpdateAccountFile = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ formData, documentType }) =>
            documentService.updateAccountFile(formData, documentType),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: [queryKeys.accountFiles] }),
    });
};

export default useUpdateAccountFile;
